import React from 'react';
import leftIcon from '../asset/leftIcon.png'; // 아이콘 경로 수정
import rightIcon from '../asset/rightIcon.png'; // 아이콘 경로 수정
import './PdfViewer.css';

const PdfFooter = ({ onPrevious, onNext }) => {
  return (
      <footer className="pdf-footer">
        <button className="nav-button" onClick={onPrevious}>
          <img src={leftIcon} alt="Previous" className="arrow-icon" />
          Previous
        </button>
        <button className="nav-button" onClick={onNext}>
          Next
          <img src={rightIcon} alt="Next" className="arrow-icon" />
        </button>
      </footer>
  );
}

export default PdfFooter;
